"use strict";const e=require("react").createContext({isMobile:!1,isTablet:!1});exports.DeviceContext=e;
//# sourceMappingURL=DeviceContext-1WlwRjZF.js.map
